<template>
  <div class="cadfm-container-horizontal">
            <Left v-show="isVisibleLeft" :lang="lang.Left"></Left>
            <Middle  :lang="lang.Middle"></Middle>
            <Right v-show="isVisibleRight" :lang="lang.Right" class="ProjectDetailsRight"></Right>

 </div>
</template>

<script>
import Left from "@/components/ProjectManager/Views/ProjectDetails/Left/Left";
import Middle from "@/components/ProjectManager/Views/ProjectDetails/Middle/Middle";
import Right from "@/components/ProjectManager/Views/ProjectDetails/Right/Right";
//import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'

export default {
  name: "ProjectDetails",
  components: {
    Left,
    Middle,
    Right
  },
  data() {
    return {
      isVisibleRight: true,
      isVisibleLeft: true
    };
  },
  props: {
    lang: Object
  }
};
</script>


<style scoped>
.ProjectDetailsRight {
  max-width: 600px;
}
</style>



// WEBPACK FOOTER //
// src/components/ProjectManager/Views/ProjectDetails.vue